import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import { TeamActions, TeamState } from '~/store/team/detail'

export default defineComponent({
  name: 'TeamDetailMixin',

  computed: {
    ...(mapState<TeamState>('team/detail', {
      team: (state: TeamState) => state.team,
      teamLoading: (state: TeamState) => state.loading
    }) as {
      team: () => TeamState['team']
      teamLoading: () => TeamState['loading']
    })
  },

  methods: {
    ...mapActions('team/detail', {
      fetchTeam: TeamActions.FETCH_TEAM_INFO,
      fetchTeamSettings: TeamActions.FETCH_TEAM_SETTINGS,
      fetchInvitedUsers: TeamActions.FETCH_INVITED_USERS,
      updateMemberRole: TeamActions.UPDATE_MEMBER_ROLE,
      removeMemberFromTeam: TeamActions.REMOVE_MEMBER,
      transferOwnership: TeamActions.TRANSFER_OWNERSHIP,
      inviteAll: TeamActions.INVITE_MEMBERS,
      inviteSingle: TeamActions.INVITE_SINGLE,
      cancelInvite: TeamActions.CANCEL_INVITE,
      fetchInviteUrl: TeamActions.FETCH_INVITE_LINK,
      resetInviteUrl: TeamActions.RESET_INVITE_LINK,
      updateAccessControlSettings: TeamActions.UPDATE_ACCESS_CONTROL_SETTINGS,
      updateTeamBasePermissions: TeamActions.UPDATE_TEAM_BASE_PERMS,
      syncVcsPermissionss: TeamActions.SYNC_VCS_PERMISSIONS
    })
  }
})
